import { render, staticRenderFns } from "./PlanificacionSemanalPage.vue?vue&type=template&id=51c35624"
import script from "./PlanificacionSemanalPage.vue?vue&type=script&lang=js"
export * from "./PlanificacionSemanalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports